module.exports = __webpack_public_path__ + "img/askmebet-support.47f995ab.png";